import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: 0,
  status: 'idle',
};


export const tabSlice = createSlice({
  name: 'tab',
  initialState,
  reducers: {
    updateTab: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { updateTab } = tabSlice.actions;

export const currentTab = (state) => state.tab.value;

export default tabSlice.reducer;
